import type { PageRequest, PageResponse, Response } from '@/types/http'
import type { MemberNoticeDTO, MessageNoticeDTO, UnreadCountAggResponse } from '@/types/notice'
import { http } from '@/utils/http'

// 平台消息，优惠通知获取
export const memberNoticePage = async (data: PageRequest = {}) => {
  return await http<PageResponse<MemberNoticeDTO>>('/app-api/member/notice/page', {
    method: 'POST',
    body: data
  })
}

// 平台消息，优惠通知已读
export const memberNoticeRead = async (data: { paramList: string[] }) => {
  return await http<Response>('/app-api/member/notice/read', {
    method: 'POST',
    body: data
  })
}

// 平台消息，优惠通知删除消息
export const deleteNotice = async (data: { paramList: string[] }) => {
  return await http<Response>('/app-api/member/notice/delete', {
    method: 'POST',
    body: data
  })
}

// 平台消息，优惠通知未读
export const getNoticeUnreadCount = async (messageType: number) => {
  return memberNoticePage({
    size: 1,
    current: 1,
    model: { messageType: messageType }
  })
}

// 平台消息，和支付未读数 agg
export const unreadCountAggApi = async (params: { messageTypes: number[] }) => {
  return await http<Response<UnreadCountAggResponse>>('/app-api/index/msg/agg/unreadcount', {
    method: 'POST',
    body: params
  })
}

// 站内信分页列表
export const notifyMessageQuery = async (data: PageRequest = {}) => {
  return await http<PageResponse<MessageNoticeDTO>>('/app-api/account/notify/message/query', {
    method: 'POST',
    body: data
  })
}

// 设置消息已读
export const updateMessageRead = async (data: { paramList: string[] }) => {
  return await http<Response>('/app-api/account/notify/message/update-read', {
    method: 'POST',
    body: data
  })
}

// 删除消息
export const deleteMessage = async (data: { paramList: string[] }) => {
  return await http<Response>('/app-api/account/notify/message/delete', {
    method: 'POST',
    body: data
  })
}

// 获取未读消息数量
export const getMessageUnreadCount = async () => {
  return await http<Response<number | string>>('/app-api/account/notify/message/get-unread-count', {
    method: 'POST'
  })
}
